<template>
  <ul class="filter-panel" :class="{ 'is-store': isStore }">
    <div class="filter-module" v-if="isShowDateSelect">
      <h4 class="filter-name">时间筛选</h4>
      <div :class="['filter-label-wrap']">
        <!--        <CustomSelect-->
        <!--          v-if="isComponent"-->
        <!--          v-model="openTimeTypeSelect"-->
        <!--          @change="resetCustomSelect"-->
        <!--          :selectList="TIME_TYPE_SELECT"-->
        <!--          :selectValue.sync="formData.serachTimeType"-->
        <!--        />-->
        <span
          @click="showDatePicker = true"
          class="label active pd-h-12"
          :style="storeActiveBgStyle"
        >
          {{ formData.startTime ? formatShowTime : '选择时间' }}
        </span>
      </div>
    </div>
    <li class="filter-module" v-if="isShowTime">
      <h4 class="filter-name">下单时间</h4>
      <div class="filter-label-wrap">
        <span
          @click="handleSelectTime(labelItem)"
          v-for="labelItem in ORDER_TIME_TYPE"
          :key="labelItem.value"
          :class="['label', currentSelectTime == labelItem.value && 'active']"
          :style="currentSelectTime == labelItem.value && storeActiveBgStyle"
        >
          {{
            labelItem.value !== -1
              ? labelItem.name
              : currentSelectTime === -1
              ? `${selectTimeFormat[0]}~${selectTimeFormat[1]}`
              : '自定义'
          }}
        </span>
      </div>
    </li>
    <li v-for="(item, index) in filterList" :key="index" class="filter-module">
      <h4 class="filter-name">
        {{ item.title }}
        <TipPop
          v-if="item.key == 'verifyStatusList'"
          :tipWord="HX_TIPS"
          max-w="60vw"
          :popoverProps="{ placement: 'right' }"
        />
      </h4>
      <div class="filter-label-wrap">
        <span
          @click="handleSeleteItem(item, labelItem)"
          v-for="(labelItem, idx) in item.labelList"
          :key="'label' + idx"
          :class="[
            'label',
            Array.isArray(formData[item.key])
              ? isActive(item, labelItem) && 'active'
              : matchLabelActive(formData[item.key], labelItem.value) &&
                'active',
          ]"
          :style="
            matchLabelActive(formData[item.key], labelItem, item) &&
            storeActiveBgStyle
          "
        >
          {{ labelItem.name }}</span
        >
      </div>
    </li>
    <!-- 订单类型支持多选 -->
    <li class="filter-module">
      <h4 class="filter-name">订单类型</h4>
      <div class="filter-label-wrap">
        <span
          @click="handleMutiSeleteItem(labelItem)"
          v-for="(labelItem, idx) in ORDER_TYPE_LIST"
          :key="'label' + idx"
          :class="[
            'label',
            (labelItem.value
              ? selectList.includes(labelItem.value)
              : selectList.length === 0) && 'active',
          ]"
          :style="
            (labelItem.value
              ? selectList.includes(labelItem.value)
              : selectList.length === 0) && storeActiveBgStyle
          "
        >
          <span>{{ labelItem.name }}</span>
        </span>
      </div>
    </li>
    <li class="filter-module">
      <h4 class="filter-name">是否代客下单</h4>
      <div class="filter-label-wrap">
        <span
          @click="handleIsAgentTakeOrder(item)"
          v-for="item in isAgentTakeOrderOptions"
          :key="item.value"
          :class="[
            'label',
            item.value === formData.isAgentTakeOrder && 'active',
          ]"
          :style="
            item.value === formData.isAgentTakeOrder && storeActiveBgStyle
          "
        >
          <span>{{ item.label }}</span>
        </span>
      </div>
    </li>
    <!-- order date picker -->
    <CustomDateTimePopup
      dateType="datetime"
      v-model="showDatePicker"
      :beginDate="formData.startTime"
      :overDate="formData.endTime"
      @confirm="onDatePickerConfirm"
      sameYear
    />
    <!-- <van-calendar
      v-model="showDatePicker"
      type="range"
      get-container="body"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onDatePickerConfirm"
      @open="openCalendar"
    /> -->
  </ul>
</template>

<script>
import {
  DELIVERY_LIST,
  ORDER_LIST,
  RECENTLY_DATE_LIST,
  VERIFY_STATUS_LIST,
  TIME_TYPE_SELECT,
  ORDER_TYPE_LIST,
  DELIVERY_TYPE,
  HX_TIPS,
  ORDER_TIME_TYPE,
} from '../../js/enum'
import { agentCommonInfoMixins } from '../../js/mixins'
import moment from 'moment'
import { getSession } from '@/utils/utils'
import { mapGetters } from 'vuex'
import CustomDateTimePopup from '@/pages/agent/components/CustomDateTimePopup'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

import TipPop from '@/pages/agent/components/tipPop'
export default {
  name: 'OrderFilterPanel',
  mixins: [agentCommonInfoMixins],
  components: {
    TipPop,
    CustomDateTimePopup,
  },
  props: {
    isCache: {
      type: Boolean,
      default: false,
    },
    isfollowType: {
      type: Boolean,
      default: true,
    },
    authData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isShowDateSelect: {
      type: [Object, Boolean],
      default: () => true,
    },
    agentSetting: {
      type: Object,
      default: () => {
        return {}
      },
    },
    levelList: Array,
    storeId: Number,
    isComponent: Boolean,
    orderTypeSelcet: {
      type: Array,
    },
    // 是否显示下单时间选项
    isShowTime: {
      type: Boolean,
      default: false,
    },
    isCustomDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      HX_TIPS,
      TIME_TYPE_SELECT,
      ORDER_TYPE_LIST,
      RECENTLY_DATE_LIST,
      ORDER_TIME_TYPE,
      showDatePicker: false,
      minDate: new Date(2008, 0, 1),
      maxDate: new Date(),
      formData: {
        verifyStatusList: [],
        deliveryTypeList: [],
        orderStatusList: [],
        deliveryType: -1,
        orderStatus: -999,
        followType: 0,
        followLevel: 0,
        orderSegmentType: '',
        startTime: moment().format('YYYY-MM-01 00:00:00'),
        endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        serachTimeType: 0,
        isAgentTakeOrder: -1,
      },
      // selectList: [200, 1227, 240, 1212, 1288, 1211, 1315, 1806, 1807],
      selectList: [], // 产品说要默认查全部
      openTimeTypeSelect: false,
      isAgentTakeOrderOptions: [
        { label: '全部', value: -1 },
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      timeType: -1,
    }
  },
  watch: {
    authData: {
      handler(val) {
        if (Object.keys(val).length) {
          this.formData.followLevel = this.authData.level || 0
          if (this.authData.level == 1) {
            this.formData.followType = 1
          }
        }
      },
      immediate: true,
    },
    orderTypeSelcet: {
      handler(val) {
        if (!val) return
        this.selectList = val
      },
      deep: true, // 深度监听
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['orderFilterParams', 'getAuthDataAndAgentSetting']),
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore(this)
    },
    storeBgStyle() {
      return StoreController.bgStyle()
    },
    storeBorderStyle() {
      return StoreController.borderStyle()
    },
    storeActiveBgStyle() {
      return StoreController.activeBgStyle()
    },
    formatShowTime({ formData }) {
      try {
        const { startTime, endTime } = formData
        if (startTime) {
          return `${moment(startTime).format('YYYY')}年 ${moment(
            startTime
          ).format('MM-DD')}至${moment(endTime).format('MM-DD')}`
        } else {
          return '选择时间'
        }
      } catch (e) {
        return '选择时间'
      }
    },
    filterList() {
      let list = [
        {
          title: '配送方式',
          key: 'deliveryTypeList',
          labelList: DELIVERY_LIST,
        },
        {
          title: '订单状态',
          key: 'orderStatusList',
          labelList: ORDER_LIST.filter(
            item =>
              item.deliveryType == DELIVERY_TYPE.COMMODITY_DISTRIBUTION ||
              item.name == '全部'
          ),
        },
        {
          title: '订单核销状态',
          key: 'verifyStatusList',
          labelList: VERIFY_STATUS_LIST,
        },
        // {
        //   title: '订单类型',
        //   key: 'orderSegmentType',
        //   labelList: ORDER_TYPE_LIST
        // }
        // {
        //   title: '日期',
        //   key: 'date',
        //   labelList: this.DateList
        // }
      ]
      // if (
      //   !this.getAuthDataAndAgentSetting.isAdminNotAgent &&
      //   !this.storeId &&
      //   this.storeId <= 0 &&
      //   this.isfollowType &&
      //   !this.isStore
      // ) {
      //   list.push({
      //     title: '身份',
      //     key: 'followType',
      //     labelList: this.levelList,
      //   })
      // }
      return list
    },
    DateList({ RECENTLY_DATE_LIST }) {
      return RECENTLY_DATE_LIST.filter(item => item.name != '全部')
    },
    currentSelectTime({ formData }) {
      const { startTime, endTime } = formData
      // 今日最后一分一秒
      const todayEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:59')
      if (endTime !== todayEndTime || this.timeType === -1) {
        return -1
      }
      const eTime = moment(endTime)
      const sTime = moment(startTime)

      // 今日
      if (eTime.diff(sTime, 'days') === 0) {
        return 1
      }

      // 近3天
      if (eTime.diff(sTime, 'days') === 2) {
        return 3
      }

      // 近7天
      if (eTime.diff(sTime, 'days') === 6) {
        return 7
      }

      // 近30天
      if (eTime.diff(sTime, 'days') === 29) {
        return 30
      }

      return -1
    },
    selectTimeFormat({ formData }) {
      return [
        moment(formData.startTime).format('YYYY-MM-DD'),
        moment(formData.endTime).format('YYYY-MM-DD'),
      ]
    },
  },
  created() {
    if (this.isShowTime) {
      if (this.isCustomDate) {
        this.timeType = -1
      } else {
        this.timeType = this.orderFilterParams?.time
      }
      this.formData.startTime =
        this.orderFilterParams?.time?.[0] || this.orderFilterParams.startTime
      this.formData.endTime =
        this.orderFilterParams?.time?.[1] || this.orderFilterParams.endTime
    } else {
      this.formData.startTime = moment(new Date())
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD')
      this.formData.endTime = this.orderFilterParams.endTime
    }
    // this.formData.startTime = this.orderFilterParams.startTime

    this.formData.orderSegmentType = this.orderFilterParams.orderSegmentType
    // 是否从本地缓存取值
    if (this.isCache && getSession('orderFilterParams')) {
      this.formData.orderStatusList = this.orderFilterParams.orderStatusList
      this.formData.deliveryTypeList = this.orderFilterParams.deliveryTypeList
      // verifyStatus不要这个字段了 兼容下
      if (
        typeof this.orderFilterParams.verifyStatus === 'number' &&
        this.orderFilterParams.verifyStatus != -1
      ) {
        this.formData.verifyStatusList = [this.orderFilterParams.verifyStatus]
      } else if (Array.isArray(this.orderFilterParams.verifyStatus)) {
        this.formData.verifyStatusList = this.orderFilterParams.verifyStatus
      } else {
        this.formData.verifyStatusList = this.orderFilterParams.verifyStatusList
      }
      this.formData.followType = this.orderFilterParams.followType
      this.formData.isAgentTakeOrder = this.orderFilterParams.isAgentTakeOrder
      this.selectList = this.orderFilterParams.orderSegmentType
      delete this.orderFilterParams.verifyStatus
    }
  },
  methods: {
    isActive(item, labelItem) {
      //   全部状态的选中条件为当前选中数组长度为0
      if (
        (['deliveryTypeList', 'verifyStatusList'].includes(item.key) &&
          labelItem.value === -1) ||
        labelItem.value === -999
      ) {
        return this.formData[item.key].length === 0
      } else {
        return this.formData[item.key].indexOf(labelItem.value) > -1
      }
    },
    resetCustomSelect() {
      this.TIME_TYPE_SELECT.forEach(item => {
        this.formData[item.value] = undefined
      })
    },
    openCalendar() {
      this.$nextTick(() => {
        const calendarDom = document.querySelector('.van-calendar__body')
        if (calendarDom) {
          let back = calendarDom.scrollTop
          setTimeout(() => {
            back = calendarDom.scrollTop
            calendarDom.scrollTop = back - 2
          }, 200)
          setTimeout(() => {
            calendarDom.scrollTop = back
          }, 500)
        }
      })
    },
    matchLabelActive(currentValue, labelItem, item) {
      if (Array.isArray(currentValue)) {
        return this.isActive(item, labelItem)
      } else {
        const labelValue = labelItem.value
        if (Array.isArray(labelValue)) {
          return currentValue.join(',') == labelValue.join(',')
        } else {
          return currentValue == labelValue
        }
      }
    },
    handleMutiSeleteItem(labelItem) {
      if (labelItem.value) {
        const findIndex = this.selectList.findIndex(
          item => item === labelItem.value
        )
        if (findIndex !== -1) this.selectList.splice(findIndex, 1)
        else this.selectList.push(labelItem.value)
      } else {
        this.selectList = []
      }
      this.$set(this.formData, 'orderSegmentType', this.selectList)
    },
    // 是否代客下单选择
    handleIsAgentTakeOrder(labelItem) {
      this.$set(this.formData, 'isAgentTakeOrder', labelItem.value)
    },
    handleSeleteItem(item, labelItem) {
      // console.log('item, labelItem', item, labelItem)
      if (item.key === 'followType') {
        // || item.key === 'verifyStatusList'
        if (this.formData[item.key] != labelItem.value) {
          this.$set(this.formData, item.key, labelItem.value)
        }
        return
      }
      if (!this.formData[item.key]) {
        this.$set(this.formData, item.key, [])
      } else {
        const allSelectedValue =
          item.key === 'deliveryTypeList' ||
          item.key === 'verifyStatus' ||
          item.key === 'verifyStatusList'
            ? -1
            : -999
        // 如果点击了全部，赋空数组
        if (labelItem.value === allSelectedValue) {
          this.formData[item.key] = []
          return
        }
        const index = this.formData[item.key].indexOf(labelItem.value)
        if (index !== -1) {
          this.formData[item.key].splice(index, 1)
        } else {
          this.formData[item.key] = this.formData[item.key].filter(
            value => value !== allSelectedValue
          )
          this.formData[item.key].push(labelItem.value)
        }
      }
    },
    onDatePickerConfirm(value) {
      let startTime = moment(value[0]).format('YYYY-MM-DD HH:mm:00')
      let endTime = moment(value[1]).format('YYYY-MM-DD HH:mm:59')
      let minYearDate = moment(moment().subtract(1, 'years')).format(
        'YYYY-MM-DD'
      )
      if (new Date(startTime).getTime() < new Date(minYearDate).getTime()) {
        return this.$toast('选择范围是近一年')
      }
      this.formData.startTime = startTime
      this.formData.endTime = endTime
      this.showDatePicker = false
    },
    handleSelectTime(item) {
      this.timeType = item.value
      if (item.value === -1) {
        this.showDatePicker = true
      } else {
        this.formData.startTime = moment()
          .subtract(item.value - 1, 'days')
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
        this.formData.endTime = moment()
          .endOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-module {
  margin-bottom: 20px;
  .filter-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 550;
    font-size: 14px;
    color: #202124;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .filter-label-wrap {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    &.comb {
      gap: 0;
      .label {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: none;
      }
    }
    .label {
      min-width: 78px;
      padding: 0 4px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      box-sizing: border-box;
      background: #f5f6f7;
      border-radius: 8px;
      border: 1px solid transparent;
      font-size: 13px;
      &.pd-h-12 {
        padding: 0 12px;
      }
      &.active {
        color: #006cff;
        background: #f0f7fe;
        border-color: #006cff;
      }
    }
  }
}
::v-deep {
  .select-button {
    border-color: var(--panel-primary);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    &.active {
      border-color: var(--panel-primary) !important;
    }
  }
}
</style>
